const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`,
        },
    ];
};
const step_schema_goods_in_transit = [
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'employment_status',
        children: [
            {
                key: 'occupation_0_type',
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
            {
                key: 'occupation_0_more',
                children: secondOccupation(),
                required_children: value => value === true,
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
        ],
    },

    //policy
    {
        key: 'company_name',
        required: false
    },
    {
        key: 'company_year'
    },
    {
        key: 'cover_duration',
    },
    {
        key: 'cover_level',
    },
    {
        key: 'use_covered',
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_goods_in_transit;
